import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetLanguagesLookups = () => {
  return useContentSelector(({ languages }) => languages.lookups);
};
